<template>
    <b-modal
        id="modal-adicionar-profissional"
        :title="modoEdicao ? 'Editar Profissional' : 'Adicionar Profissional'"
        v-model="visivel"
        @ok="handleOk"
        ok-title="Salvar"
        cancel-title="Cancelar"
        :ok-button-props="{ class: 'btn-custom-azul' }"
        size="lg"
    >
        <form @submit.stop.prevent="handleOk">
            <b-row>
                <b-col md="6">
                    <b-form-group label-for="cpf">
                        <template #label>
                            CPF <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                            id="cpf"
                            v-model="novoProfissional.cpf"
                            v-mask="'###.###.###-##'"
                            placeholder="000.000.000-00"
                            @keyup="verificarCpfCompleto"
                            :disabled="modoEdicao"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                 <b-col md="6">
                    <b-form-group label="Registro Profissional" label-for="registro">
                        <b-form-input
                            id="registro"
                            v-model="novoProfissional.registroProfissional"
                            placeholder="Ex: CREA, CRM, etc."
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="12">
                    <b-form-group label-for="nome-completo">
                        <template #label>
                            Nome Completo <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                            id="nome-completo"
                            v-model="novoProfissional.nomeCompleto"
                            placeholder="Nome completo do profissional"
                            :disabled="nomeBloqueado"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="6">
                    <b-form-group label-for="cargo">
                        <template #label>
                            Cargo <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                            id="cargo"
                            v-model="novoProfissional.cargo"
                            placeholder="Cargo ocupado"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Função" label-for="funcao">
                        <b-form-input
                            id="funcao"
                            v-model="novoProfissional.funcao"
                            placeholder="Função desempenhada"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <small class="text-danger">* Campos obrigatórios</small>
        </form>
    </b-modal>
</template>

<script>
import BoletimMedicaoServicos from '../../../BoletimMedicaoServicos.js';

export default {
    name: 'DeclaracaoVinculoModal',
    props: {
        contratoId: {
            type: String,
            required: true
        },
        itens: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            visivel: false,
            novoProfissional: {
                nomeCompleto: '',
                cpf: '',
                cargo: '',
                funcao: '',
                registroProfissional: ''
            },
            nomeBloqueado: false,
            modoEdicao: false,
            profissionalId: null,
            vinculoId: null
        }
    },
    methods: {
        show(profissional = null) {
            if (profissional) {
                this.modoEdicao = true;
                this.profissionalId = profissional.profissionalId || profissional.id;
                this.vinculoId = profissional.id;
                this.novoProfissional = {
                    nomeCompleto: profissional.nomeCompleto,
                    cpf: profissional.cpf,
                    cargo: profissional.cargo,
                    funcao: profissional.funcao,
                    registroProfissional: profissional.registroProfissional
                };
                this.nomeBloqueado = false; 
            } else {
                this.modoEdicao = false;
                this.profissionalId = null;
                this.vinculoId = null;
                this.novoProfissional = {
                    nomeCompleto: '',
                    cpf: '',
                    cargo: '',
                    funcao: '',
                    registroProfissional: ''
                };
                this.nomeBloqueado = false;
            }
            this.visivel = true;
        },
        hide() {
            this.visivel = false;
        },
        verificarCpfCompleto() {
             const cpfLimpo = this.novoProfissional.cpf ? this.novoProfissional.cpf.replace(/\D/g, '') : '';

             if (cpfLimpo.length === 11) {
                 this.buscarProfissionalPorCpf(cpfLimpo);
             } else {
                 if(this.nomeBloqueado) {
                     this.nomeBloqueado = false;
                 }
             }
        },
        buscarProfissionalPorCpf(cpf) {
            // Se estiver editando, talvez não queiramos sobrescrever os dados com a busca se o usuário estiver alterando o CPF
            // Mas vamos manter o comportamento padrão para ajudar no preenchimento
            this.$store.dispatch('addRequest');
            BoletimMedicaoServicos.autocompleteProfissional(this.contratoId, cpf)
                .then(response => {
                    // Limpa os campos se não encontrar, mas cuidado se estiver editando...
                    // Melhor lógica: Se encontrou, preenche. Se não encontrou, deixa o usuário preencher.
                    // O código original limpava. Vamos manter, mas cuidado no modo edição.
                    
                    if (response && response.success && response.data && response.data.encontrado) {
                        const dados = response.data;
                        this.novoProfissional.nomeCompleto = dados.nomeCompleto;
                        this.novoProfissional.cargo = dados.ultimoCargo || '';
                        this.novoProfissional.funcao = dados.ultimaFuncao || '';
                        this.novoProfissional.registroProfissional = dados.ultimoRegistroProfissional || '';

                        this.nomeBloqueado = true;
                        this.$toast.success('Profissional encontrado na base de dados.');
                    } else {
                         // Se não encontrou, libera o nome para edição
                        this.nomeBloqueado = false;
                        // Não limpamos os campos para não apagar o que o usuário pode ter digitado ou o que veio da edição,
                        // a menos que seja um novo cadastro onde queremos limpar se o CPF mudar para um não existente.
                        // O código original limpava tudo.
                        if (!this.modoEdicao) {
                             this.novoProfissional.nomeCompleto = '';
                             this.novoProfissional.cargo = '';
                             this.novoProfissional.funcao = '';
                             this.novoProfissional.registroProfissional = '';
                        }
                    }
                    this.$store.dispatch('removeRequest');
                })
                .catch(error => {
                    this.nomeBloqueado = false;
                    if (!this.modoEdicao) {
                        this.novoProfissional.nomeCompleto = '';
                        this.novoProfissional.cargo = '';
                        this.novoProfissional.funcao = '';
                        this.novoProfissional.registroProfissional = '';
                    }
                    this.$store.dispatch('removeRequest');
                });
        },
        handleOk(bvModalEvt) {
            if (!this.novoProfissional.nomeCompleto || !this.novoProfissional.cpf || !this.novoProfissional.cargo) {
                this.$toast.warning('Os campos Nome, CPF e Cargo são obrigatórios.', 'Atenção', this.$toastConfig.warning);
                if (bvModalEvt && bvModalEvt.preventDefault) {
                    bvModalEvt.preventDefault();
                }
                return;
            }

            const profissionalParaSalvar = {
                ...this.novoProfissional
            };

            if (profissionalParaSalvar.cpf) {
                profissionalParaSalvar.cpf = profissionalParaSalvar.cpf.replace(/\D/g, '');
            }

            const cpfExistente = this.itens.some(item => {
                // Se estiver editando, ignora o próprio item
                const itemProfissionalId = item.profissionalId || item.id;
                if (this.modoEdicao && itemProfissionalId === this.profissionalId) return false;

                const cpfItemLimpo = item.cpf ? item.cpf.replace(/\D/g, '') : '';
                return cpfItemLimpo === profissionalParaSalvar.cpf;
            });

            if (cpfExistente) {
                this.$toast.warning('Profissional já registrado neste boletim de medição.', 'Atenção', this.$toastConfig.warning);
                if (bvModalEvt && bvModalEvt.preventDefault) {
                    bvModalEvt.preventDefault();
                }
                return;
            }

            if (this.modoEdicao) {
                this.$emit('atualizar', { 
                    profissionalId: this.profissionalId, 
                    id: this.vinculoId,
                    ...profissionalParaSalvar 
                });
            } else {
                this.$emit('salvar', profissionalParaSalvar);
            }

            if (bvModalEvt && bvModalEvt.preventDefault) {
                bvModalEvt.preventDefault();
            }
        }
    }
}
</script>

<style>
.btn-custom-azul {
    background-color: #2F5597 !important;
    border-color: #2F5597 !important;
    color: #fff !important;
}

.btn-custom-azul:hover {
    background-color: #244276 !important;
    border-color: #244276 !important;
    color: #fff !important;
}
</style>
